import type { ILanguageResources, ITranslationModule } from '../../interfaces';
import { interpolate } from '../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.api.ApiResponseHandler.';
  public static readonly clientSessionInvalid = `${Id.prefix}clientSessionInvalid`;
  public static readonly duplicateLogin = `${Id.prefix}duplicateLogin`;
  public static readonly systemOfflineMsg = `${Id.prefix}systemOfflineMsg`;
  public static readonly systemOfflineTitle = `${Id.prefix}systemOfflineTitle`;
  public static readonly serverErrorOccurred = `${Id.prefix}serverErrorOccurred`;
  public static readonly validationIssuesFromServer = `${Id.prefix}validationIssuesFromServer`;
}

export class LangApiResponseHandler {
  private constructor() {}
  public static clientSessionInvalid(): string {
    return interpolate(Id.clientSessionInvalid);
  }
  public static duplicateLogin(): string {
    return interpolate(Id.duplicateLogin);
  }
  public static systemOfflineMsg(): string {
    return interpolate(Id.systemOfflineMsg);
  }
  public static systemOfflineTitle(): string {
    return interpolate(Id.systemOfflineTitle);
  }
  public static serverErrorOccurred(): string {
    return interpolate(Id.serverErrorOccurred);
  }
  public static validationIssuesFromServer(): string {
    return interpolate(Id.validationIssuesFromServer);
  }
}

export class ApiResponseHandlerModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.clientSessionInvalid,
      'Your client session is no longer valid. Refreshing Page to attempt recovery',
      'Message shown when client session is invalid and page will refresh'
    );
    register.add(
      Id.duplicateLogin,
      'You are being disconnected as your account is logged into another machine (or Browser)',
      'Message shown when duplicate login is detected'
    );
    register.add(
      Id.systemOfflineMsg,
      'Cannot communicate with the server. There may be a network outage. please check your internet and try again',
      'Message shown when system is offline'
    );
    register.add(Id.systemOfflineTitle, 'System OFFLINE', 'Title for system offline dialog');
    register.add(Id.serverErrorOccurred, 'Server Error Occurred', 'Message shown when a server error occurs');
    register.add(
      Id.validationIssuesFromServer,
      'Validation Issues from Server',
      'Message shown when validation errors are returned from the server'
    );
  }
}
